import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { Card, CardTitle, lineItemHelpers, LineItemSelector, ProductDetailDrawer, Text } from '@reveni-io/reveni-ui'

import RMAContext from '@/returns/pages/TransactionRMAPage/context/RMAContext'
import returnsServices from '@/returns/services/services'

import useShippingAddress from '../hooks/useShippingAddress/useShippingAddress'
import useProductDetailDrawer from './hooks/useProductDetailDrawer/useProductDetailDrawer'
import * as Styles from './styles'

const ProductsCard = ({ lineItems, merchantInfo, createRma, updateRma, getDeliveryMethods }) => {
  const { t } = useTranslation()
  const { rmaInfo, setRmaInfo } = useContext(RMAContext)
  const { regionId } = useShippingAddress()

  const {
    getActionType,
    getCustomerImageUrl,
    getCustomerNotes,
    getReasonDisplay,
    getSubReasonDisplay,
    isItemSelected,
    getNewRequestedProduct,
    getExtraProducts,
  } = lineItemHelpers(rmaInfo.items)

  const { openProductDetailDrawer, closeProductDetailDrawer, showProductDetailDrawer, selectedProduct } =
    useProductDetailDrawer()

  const showTransactionTypeSelector = item => item?.available_transaction_types?.length > 1

  const isReturnable = item => item?.available_transaction_types?.length > 0

  const getItemDefaultTransactionType = item => item?.available_transaction_types?.[0]

  const handleOnConfirmSelection = async items => {
    let data = null
    if (rmaInfo?.orderInfo?.returnId) {
      data = await updateRma(items)
    } else {
      data = await createRma(items)
    }

    if (!data) return

    getDeliveryMethods({ orderId: rmaInfo?.orderInfo?.id, regionId, returnId: data.id })
  }

  return (
    <>
      <Card showBorder={false}>
        <CardTitle>{t('Productos')}</CardTitle>

        <Text type="bodyMRegular">{t('Selecciona al menos un producto para continuar')}:</Text>
        <Styles.ItemsContainer>
          {lineItems?.map((item, index) => (
            <LineItemSelector
              key={item?.id}
              lineItem={{
                ...item,
                actionType: getActionType(item.id),
                reason_display: getReasonDisplay(item.id),
                subreason_display: getSubReasonDisplay(item.id),
                customer_notes: getCustomerNotes(item.id),
                customer_image_url: getCustomerImageUrl(item.id),
              }}
              merchantInfo={merchantInfo}
              onClick={() => openProductDetailDrawer(item)}
              newItem={getNewRequestedProduct(item)}
              extraProducts={getExtraProducts(item)}
              isReturnable={isReturnable(item)}
              notReturnableReason={item?.is_returnable_reason}
              selected={isItemSelected(item.id)}
              index={index + 1}
              clickable={isReturnable(item)}
              outOfPolicy={item?.outOfPolicy}
            />
          ))}
        </Styles.ItemsContainer>
      </Card>
      <ProductDetailDrawer
        show={showProductDetailDrawer}
        onClose={closeProductDetailDrawer}
        product={selectedProduct}
        context={rmaInfo}
        setContext={setRmaInfo}
        isCancellationsPortal={false}
        getItemDefaultTransactionType={getItemDefaultTransactionType}
        showTransactionTypeSelector={showTransactionTypeSelector}
        getReturnReasonsService={returnsServices.getProductReturnReasons}
        uploadProductImageService={returnsServices.uploadOrdersProductImage}
        getProductsTaxonomyService={returnsServices.getProductsTaxonomy}
        getProductsByTaxonomyService={returnsServices.getProductsByTaxonomy}
        searchProductsService={returnsServices.searchProducts}
        getVariantsByProductService={returnsServices.getVariantsByProduct}
        onConfirm={handleOnConfirmSelection}
        onCancel={handleOnConfirmSelection}
      />
    </>
  )
}

export default ProductsCard
